// IO-grain Sentinel rules (io_under_pace, io_over_pace, io_delivery_drop,
// io_delivery_spike) are anchored to the insertion order, not a single campaign — the
// campaign a server row carries is now just a stable representative sibling. isIORule
// lets the dashboard treat the IO as the primary entity for these rows.
const isIORule = (ruleId: string): boolean => ruleId.startsWith('io_');

export default isIORule;
